import { useQuery } from '@tanstack/react-query';
import { getFilterOptions } from '../../api/apiStorefront';
import i18next from "i18next";

export const useGetFilterOptions = () => {
    return useQuery({
        queryKey: ['filter-options', i18next.language],
        queryFn: getFilterOptions,
        staleTime: 1000 * 60 * 60, // 1 hour
        retry: false,
        select: (response) => response?.data?.data,
    });
};
